export const PLATFORM_OAUTH_CALLBACK = 'platform-oauth-callback' as const
export const PLATFORM_OAUTH_RESULT = 'platform-oauth-result' as const

export type QuickBooksCallbackMessage = {
  type: typeof PLATFORM_OAUTH_CALLBACK
  platform: 'QuickBooks'
  code: string
  realmId: string
}

export type QuickBooksResultMessage =
  | {
      type: typeof PLATFORM_OAUTH_RESULT
      platform: 'QuickBooks'
      status: 'success'
    }
  | {
      type: typeof PLATFORM_OAUTH_RESULT
      platform: 'QuickBooks'
      status: 'error'
      error: string
    }

export function isQuickBooksCallbackMessage(value: unknown): value is QuickBooksCallbackMessage {
  if (!value || typeof value !== 'object') return false
  const message = value as Partial<QuickBooksCallbackMessage>
  return (
    message.type === PLATFORM_OAUTH_CALLBACK &&
    message.platform === 'QuickBooks' &&
    typeof message.code === 'string' &&
    message.code.length > 0 &&
    typeof message.realmId === 'string' &&
    message.realmId.length > 0
  )
}

export function isQuickBooksResultMessage(value: unknown): value is QuickBooksResultMessage {
  if (!value || typeof value !== 'object') return false
  const message = value as Partial<QuickBooksResultMessage>
  if (message.type !== PLATFORM_OAUTH_RESULT || message.platform !== 'QuickBooks') return false
  if (message.status === 'success') return true
  return message.status === 'error' && typeof message.error === 'string' && message.error.length > 0
}
